import { Locale } from 'next-intl'

const CURRENCY_SYMBOLS = {
  TWD: 'NT$',
  USD: 'USD$',
  JPY: '¥',
} as const

type KnownCurrencyCode = keyof typeof CURRENCY_SYMBOLS

type CurrencyCode = KnownCurrencyCode | (string & {})

export const mapLocaleToStoreCode = (locale?: Locale) => {
  switch (locale) {
    case 'zh-TW':
      return 'global_tw_zhtw'
    case 'ja-JP':
      return 'global_jp_jajp'
    case 'en-US':
    default:
      return 'global_us_enus'
  }
}

export const getCurrencySymbol = (currencyCode?: string): string => {
  if (!currencyCode) return ''
  const upper = currencyCode.toUpperCase() as CurrencyCode
  return (CURRENCY_SYMBOLS as Record<string, string>)[upper] ?? upper
}

export const PAYMENT_TYPE = {
  oneTime: 'ONE_TIME',
  subscription: 'SUBSCRIPTION',
} as const

const DURATION_TYPE = {
  monthly: 'month',
  annually: 'annual',
} as const

export const getDurationType = (durationUnit?: string): string => {
  if (!durationUnit) return ''
  return (DURATION_TYPE as Record<string, string>)[durationUnit] ?? durationUnit
}
